import { render, staticRenderFns } from "./duplications.vue?vue&type=template&id=b3819ab2&"
import script from "./duplications.vue?vue&type=script&lang=js&"
export * from "./duplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports